
import { Component, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { AppCommonModule } from 'src/app/common.module';
import { MainDialogComponent } from 'src/app/components/main-dialog/main-dialog.component';
import { PickMediaComponent } from 'src/app/components2/pick-media/pick-media.component';
import { SelectAreaDialogComponent } from 'src/app/components/select-area/select-area.dialog';
import { FileUpload } from 'src/app/models/file.model';
import { Room } from 'src/app/models/room.model';
import { Site } from 'src/app/models/site.model';
import { UploadService } from 'src/app/services/upload.service';
import { deepClone } from 'src/app/utility/object';

export interface SiteReportNote {
  images: string[];
  name: string;
  area: string;
  text: string;
}

@Component({
  selector: 'app-new-report-note-dialog',
  templateUrl: './new-note.dialog.html',
  styleUrls: ['./new-note.dialog.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    AppCommonModule,
    MainDialogComponent,
    PickMediaComponent,
  ],
})
export class NewReportNoteDialogComponent {
  private formBuilder = inject(FormBuilder);
  private _modal = inject(ModalController);
  private modalCtrl = inject(ModalController);
  private uploadService = inject(UploadService);

  site = input<Site>();

  readonly formGroup = this.formBuilder.group({
    name: ['', Validators.required],
    text: [''],
    images: [Array.from<string>([])],
    area: [null],
  });

  onUrl(url: string) {
    const images = this.formGroup.get('images').value ?? [];
    images.push(url);
    this.formGroup.get('images').setValue(images);
  }

  onUrls(urls: string[]) {
    const images = this.formGroup.get('images').value ?? [];
    images.push(...urls);
    this.formGroup.get('images').setValue(images);
  }

  async onFilesSelected(files: File[]) {
    for (const file of files) {
      if (!file.type.startsWith('image/') && !file.type.startsWith('video/')) {
        continue;
      }
      const fileUpload = new FileUpload(file);
      fileUpload.guid = `report-note-${this.site()?.guid ?? 'site'}-${file.name}-${new Date().toISOString()}`;
      const url = await this.uploadService.uploadImage(fileUpload);
      this.onUrl(url);
    }
  }

  selectArea() {
    const site = this.site();
    this.modalCtrl.create({ component: SelectAreaDialogComponent, componentProps: { site } }).then((m) => {
      m.present();

      m.onDidDismiss<Room>().then((data) => {
        if (data.data) {
          const room = deepClone(data.data);
          const roomName = room.siteArea ? `${room.siteArea.name} / ${room.id}` : room.id;
          this.formGroup.get('area').setValue(roomName);
        }
      });
    });
  }

  onSave() {
    const item = this.formGroup.value;
    this._modal.dismiss(item);
  }

  dismiss() {
    this._modal.dismiss();
  }
}
